// `combo` , a bundled meal deal combining multiple items at a set price.
// The core merchandising unit of fast food (doc 47 Phase 7 F1).
// A combo bundles multiple items at a bundle price. The customer picks from
// predefined slots (e.g. "choose 1 drink") and gets a discount vs ordering
// à la carte.

import { z } from 'zod';

import type { ItemKindDefinition } from './registry-types';
import type { ComboProfile } from './types';

const COMBO_COMPONENT_SCHEMA = z.object({
  slot: z.string().min(1).max(100),
  eligible_item_ids: z.array(z.string().uuid()).min(1),
  default_id: z.string().uuid().nullable().optional(),
  included_qty: z.number().int().min(1).default(1),
});

export const comboProfileSchema = z.object({
  components: z.array(COMBO_COMPONENT_SCHEMA).min(1),
});

export const comboKind: ItemKindDefinition<ComboProfile> = {
  id: 'combo',
  label: 'Combo',
  noun: 'combo',
  description: 'A bundled meal deal combining multiple items at a set price.',
  defaultPricingMode: 'flat',
  allowedPricingModes: ['flat'],
  schema: comboProfileSchema as unknown as z.ZodType<ComboProfile>,
  defaultProfile: () => ({ components: [] }) as ComboProfile,
};
